// Referral Enums
export enum RewardMode {
  LEVEL = 'LEVEL',
  DONATION = 'DONATION'
}

// Capsule content item
export interface ReferralCapsuleContentDto {
  id: number;
  name: string;
  icon: string;
  iconPanel: string;
  wikiItemLevel?: number;
  minCount: number;
  maxCount: number;
  chance: number;
}

// Referral Reward Item Info (with capsule contents)
export interface ReferralRewardItemInfoDto {
  id: number;
  icon: string;
  iconPanel: string;
  name: string;
  wikiCategoryId?: number | null;
  wikiSubCategoryId?: number | null;
  wikiTypeId?: number | null;
  wikiSubTypeId?: number | null;
  capsuleContents?: ReferralCapsuleContentDto[];
}

// Level reward progress
export interface ReferralLevelProgressDto {
  rewardConfigId: number;
  levelThreshold: number;
  achieved: boolean;
  claimed: boolean;
  rewardItem: ReferralRewardItemInfoDto;
  rewardItemCount: number;
}

// Donation tier progress
export interface ReferralDonationProgressDto {
  rewardConfigId: number;
  levelThreshold: number;
  achieved: boolean;
  donationPercent: number;
}

// Donation info with tiers
export interface ReferralDonationInfoDto {
  accumulatedEarnings: number;
  tiers: ReferralDonationProgressDto[];
}

// Single referral info
export interface ReferralInfoDto {
  referralId: number;
  username: string;
  email: string;
  maxLevel: number;
  maxLevelCharName: string;
  maxLevelAccountName: string;
  rewardMode: RewardMode;
  modeLocked: boolean;
  levelRewards?: ReferralLevelProgressDto[];
  donationInfo?: ReferralDonationInfoDto;
}

export interface AdminReferralInfoDto extends ReferralInfoDto {
  userId: number;
  totalDonated: number;
}

export interface AdminReferralListDto {
  totalDonated: number;
  referrals: AdminReferralInfoDto[];
}

// My referrer info
export interface MyReferrerInfoDto {
  referrerUsername: string;
  myMaxLevel: number;
  availableRewards: ReferralLevelProgressDto[];
}

// Alias
export type ReferralDto = ReferralInfoDto;

export interface MyReferralInfoDto {
  referralCode: string;
  canBindReferral: boolean;
  rewardClaimEnabled: boolean;
}

export interface BindReferralCodeDto {
  referralCode: string;
}

export interface SwitchRewardModeDto {
  rewardMode: RewardMode;
}

// Referral Admin Types
export interface CreateReferralSelfRewardConfigDto {
  levelThreshold: number;
  itemId: number;
  itemCount: number;
}

export interface ReferralSelfRewardConfigDto {
  id: number;
  levelThreshold: number;
  item: ReferralRewardItemInfoDto;
  itemCount: number;
}

export interface CreateReferralLevelRewardConfigDto {
  levelThreshold: number;
  itemId: number;
  itemCount: number;
}

export interface ReferralLevelRewardConfigDto {
  id: number;
  levelThreshold: number;
  item: ReferralRewardItemInfoDto;
  itemCount: number;
}

export interface CreateReferralDonationPercentConfigDto {
  levelThreshold: number;
  donationPercent: number;
}

export interface ReferralDonationPercentConfigDto {
  id: number;
  levelThreshold: number;
  donationPercent: number;
}

export interface AdminBindReferralDto {
  referredUserEmail: string;
  referrerUserEmail: string;
}
